type GroupSource = {
  field_groups?: unknown[]
  groups?: unknown[]
}

/**
 * Resolves tab/LIST group metadata for passport runtime layout.
 * Object-type GET often returns empty `field_groups` while the passport payload embeds the same data under `groups`.
 */
export function resolveRuntimeFieldGroups(
  fromObjectType: GroupSource,
  embeddedInventType: GroupSource,
): unknown[] | undefined {
  const q = fromObjectType.field_groups
  const e = embeddedInventType.field_groups
  const qg = fromObjectType.groups
  const eg = embeddedInventType.groups

  if (Array.isArray(q) && q.length > 0) return q
  if (Array.isArray(e) && e.length > 0) return e
  if (Array.isArray(qg) && qg.length > 0) return qg
  if (Array.isArray(eg) && eg.length > 0) return eg
  if (Array.isArray(q)) return q
  if (Array.isArray(e)) return e
  if (Array.isArray(qg)) return qg
  if (Array.isArray(eg)) return eg
  return undefined
}
